import React from "react";

import { Box } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

interface Props {
  step: number;
  totalSteps?: number;
  subtitle?: string;
}

const Header: React.FC<Props> = ({
  step,
  totalSteps = 2,
  subtitle = "Create a new account and continue with us",
}) => {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Box>
        <Box
          component="h1"
          margin={0}
          fontSize={28}
          fontWeight={700}
          lineHeight="32px"
          letterSpacing={-0.5}
          color={colors.dark}
          marginBottom={4}
        >
          Register
        </Box>
        <Box
          fontSize={14}
          lineHeight={1.3}
          fontWeight={600}
          letterSpacing={-0.5}
          color={colors.mapped.text.subheading}
        >
          {subtitle}
        </Box>
      </Box>
      <Box
        fontSize={18}
        lineHeight={1}
        fontWeight={600}
        letterSpacing={-0.5}
        color={colors.dark}
        flexShrink={0}
        marginLeft={2}
        aria-label={`Step ${step} of ${totalSteps}`}
      >
        {step}/{totalSteps}
      </Box>
    </Box>
  );
};

export default Header;
